import React from 'react'
import europeImg from '../../Images/Europe/susan-yin-62145-unsplash.jpg'
import asiaImg from '../../Images/Asia/rafa-prada-33648-unsplash.jpg'
import americaImg from '../../Images/America/erik-lindgren-23216-unsplash.jpg'
import { Link } from 'react-router-dom'


export default function EmptyCart() {
  return (
    <div className='card-body'>
      <h5 className='card-subtitle text-center'>It's seems that you have no items in cart</h5>
      <h6 className='card-subtitle my-3 text-center w-100'>Check our offers here!</h6>
      <div className='row'>
      <div className='col-12 col-lg-4'>
      <img src={europeImg} class="card-img-top" alt="Europe" />
      <h5 class="card-title">Europe</h5>
      <p className='card-text'>Discover castles, voyage through history, visit the oldest continent</p>
      <div className='w-100 text-right'>

      <Link to='/europe' class="card-link">More info</Link>
      </div>
      </div>
      <div className='col-12 col-lg-4'>
      <img src={asiaImg} class="card-img-top" alt="Asia" />
      <h5 class="card-title">Asia</h5>
      <p className='card-text'>Discover secrets in remote forests, celebrate variety of colors, sink in enduring traditions</p>
      <div className='w-100 text-right'>

      <Link to='/asia' class="card-link">More info</Link>
      </div>
      </div>
      <div className='col-12 col-lg-4'>
      <img src={americaImg} class="card-img-top" alt="America" />
      <h5 class="card-title">America</h5>
      <p className='card-text'>Discover ancient civilisations, learn about it's monumental history, feel the roar of great waterfalls</p>
      <div className='w-100 text-right'>

      <Link to='/america' class="card-link">More info</Link>
      </div>
      </div>
      </div>
      
    </div>
  )
}
